import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import style from '../cssmodules/heroPanel.module.scss';
import Button from './Button';

function HeroPanel({ title, button, image }) {
  return (
    <div className={style.heroPanel}>
      <div className={style.content}>
        <h1>{title}</h1>
        <Button link="/about" modifyer="btnVioletRed">
          {button}
        </Button>
      </div>
      <div className={style.image}>
        <Img fluid={image.childImageSharp.fluid} />
      </div>
    </div>
  );
}

HeroPanel.propTypes = {
  title: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  image: PropTypes.shape({
    childImageSharp: PropTypes.object.isRequired,
  }).isRequired,
};

export default HeroPanel;
